import React, { useEffect, useRef, useState } from 'react';
import { useWallet } from '../../context/WalletContext';
import { useContracts } from '../../context/ContractContext';
import { useNotify } from '../../context/NotifyContext';
import Card from '../common/Card';
import Button from '../common/Button';
import InlineLoader from '../common/InlineLoader';

export default function ReferralInfo() {
  const { account } = useWallet();
  const { main } = useContracts();
  const { notify } = useNotify();
  const [uid, setUid] = useState('0');
  const [loading, setLoading] = useState(true);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    if (!account) { setLoading(false); return; }
    const load = async () => {
      try {
        const id = await main.addrToId(account);
        if (!mountedRef.current) return;
        setUid(id.toString());
        setLoading(false);
      } catch (_) {
        if (mountedRef.current) setLoading(false);
      }
    };
    setLoading(true);
    load();
    return () => { mountedRef.current = false; };
  }, [account, main]);

  const isRegistered = uid !== '0';
  const link = isRegistered ? `${window.location.origin}/register?ref=${uid}` : '';

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      notify('success', 'Referral link copied');
    } catch {
      notify('error', 'Failed to copy');
    }
  };

  const copyId = async () => {
    try {
      await navigator.clipboard.writeText(uid);
      notify('success', 'ID copied');
    } catch {
      notify('error', 'Failed to copy');
    }
  };

  if (loading) return <Card title="Referral"><InlineLoader /></Card>;
  if (!isRegistered) return <Card title="Referral"><div className="empty-state">Register first to get your referral ID</div></Card>;

  return (
    <Card title="Your Referral" glow>
      <div className="input-group">
        <label className="input-label">Your Referral ID</label>
        <div style={{ display: 'flex', gap: 8 }}>
          <input className="input mono" value={uid} readOnly />
          <Button variant="ghost" size="sm" onClick={copyId}>COPY</Button>
        </div>
      </div>
      <div className="input-group">
        <label className="input-label">Referral Link</label>
        <div style={{ display: 'flex', gap: 8 }}>
          <input className="input mono" value={link} readOnly />
          <Button variant="primary" size="sm" onClick={copyLink}>COPY LINK</Button>
        </div>
      </div>
    </Card>
  );
}
